module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00042.067afe5.png";